<template>
  <div>
    <el-table v-loading="loading" :data="dataList" :height="height">
      <el-table-column label="方案名称" width="120" align="center" prop="planName" />
      <el-table-column label="设计者" width="100" align="center" prop="designer" />
      <el-table-column label="方案描述" min-width="150" align="center" :show-overflow-tooltip="true" prop="planDesc" />
      <el-table-column label="方案附件" min-width="200" align="center" prop="fileUrls">
        <template slot-scope="scope">
          <FileUpload v-model="scope.row.fileUrls" :limit="5" :readOnly="true"></FileUpload>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="删除方案" :visible.sync="visible" width="30%">
      <p>您已选中{{updateData.type}}角色</p>
      <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="120px">
        <el-form-item label="更改后联系人:" prop="contactId">
          <el-select v-model="updateData.contactId" placeholder="请选择更改后联系人" clearable style="width:100%">
            <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
    </el-dialog>
    <AddBusinessPlanDialog ref="addBusinessPlanDialogRef" @success="queryList"></AddBusinessPlanDialog>
  </div>
</template>

<script>

import {queryBusinessPlan, changeBusinessPlan} from "@/api/crm/business";
import AddBusinessPlanDialog from "@/views/crm/business/addBusinessPlanDialog";
import FileUpload from "@/views/crm/components/fileUpload";

export default {
  name: "BusinessPlanList",
  props: {
    businessId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      dataList: [],
      contactList: [],
      updateData: {
        id: null,
        businessId: null,
        type: null,
        contactId: null
      },
      updateRules: {
        contactId: [
          {required: true, type: 'number', message: '请选择更改后联系人', trigger: 'change'}
        ]
      }
    };
  },
  created() {
    if (this.businessId) {
      this.queryList();
    }
  },
  components: {
    AddBusinessPlanDialog,
    FileUpload,
  },
  watch: {
    businessId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    visible (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    queryList () {
      this.loading = true;
      queryBusinessPlan({id: this.businessId}).then(response => {
        this.dataList = response.data;
        this.$emit('after-query', response.data || []);
        this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      })
    },
    handleDelete(row) {
      this.updateData = row;
      this.updateData.delFlag = 1;
      this.updateData.businessId = this.businessId
      this.$confirm('确认移除该方案(' + row.planName + ')吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        changeBusinessPlan(this.updateData).then(response => {
          // 刷新页面
          this.queryList()
          this.refreshOperateLogList()
          this.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
      });
    },
    handleEdit(row) {
      this.$refs.addBusinessPlanDialogRef.open(this.businessId, row);
    },
    confirm () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          changeBusinessPlan(this.updateData).then(response => {
            this.queryList();
            this.$emit('after-change');
            this.visible = false;
            loading.close();
            this.msgSuccess("竞争对手更改成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
